import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-booking-not-allowed-dialog',
  templateUrl: './booking-not-allowed-dialog.component.html',
  styleUrls: ['./booking-not-allowed-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingNotAllowedDialogComponent {
  constructor() {}
}
